export class EnregistrerSignature {
    username: string;
    signature:string;
    signatureContentType:string;
  }
  